import { useEffect, useState } from 'react';

import { Modal as ModalAntD, PageHeader, Result } from 'antd';
import moment from 'moment';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import { getVoucherDetail, updateVouchers } from '../../../hooks/vouchers';
import {
  setUsersVoucherList,
  setVoucherFormValues,
} from '../../../redux/actions/voucher';
import { FORM_VALUES_INITIAL_STATE } from '../../../redux/reducers/voucher';
import VoucherIcon from '../../atoms/icons/VoucherIcon';
import { COLORS } from '../../molecules/ConnectorColored/helpers';
import VoucherForm, {
  VoucherExpireType,
} from '../../organisms/VoucherForm/VoucherForm';
import { VoucherUserSelectedPksWithVoucherStatus } from '../../organisms/VoucherSelectUsersList/VoucherSelectUsersList';
import * as S from '../VoucherCreatePage/styled';

const Modal: any = ModalAntD;

const user = JSON.parse(localStorage.getItem('auth-user') as any);

const rawMaskMoney = (value: string) => {
  const onlyDigits = value
    .split('')
    .filter((s) => /\d/.test(s))
    .join('')
    .padStart(3, '0');

  const digitsFloat = onlyDigits.slice(0, -2) + '.' + onlyDigits.slice(-2);

  return digitsFloat;
};

const VoucherEditPage = ({ chargePointsList }: any) => {
  const { id }: any = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const userPks = useSelector((state: any) => state?.voucher?.userPks);
  const formValues = useSelector((state: any) => state?.voucher?.formValues);

  const [voucherDetail, setVoucherDetail] = useState<any>();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const shouldUseFormValues = Object.values(formValues).some(
    (valor) => typeof valor === 'string' && valor.trim() !== '',
  );

  function getUsersWhoActivedVoucher() {
    const usersWithVoucherStatus =
      voucherDetail?.voucher_users_pks_with_voucher_status?.filter(
        (user) => user.source === 'GUEST',
      );
    if (usersWithVoucherStatus?.length !== 0) {
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    (async () => {
      const responseDetail: any = await getVoucherDetail(id);

      setVoucherDetail(responseDetail);

      loadVoucherSelectedUsers(responseDetail);
    })();
  }, [id]);

  const clearVoucherTemporaryValues = () => {
    dispatch(setUsersVoucherList([]));

    dispatch(setVoucherFormValues(FORM_VALUES_INITIAL_STATE));
  };

  const loadVoucherSelectedUsers = (responseDetail: any) => {
    if (userPks.length > 0) return;

    const usersSelectedOnPreviousScreen = (history.location.state as any)
      ?.userSelectedPks;
    const usersAlreadyInVoucher =
      responseDetail?.voucher_users_pks_with_voucher_status;

    const usersToLoad =
      usersSelectedOnPreviousScreen ?? usersAlreadyInVoucher ?? [];

    if (usersToLoad.length > 0) {
      dispatch(setUsersVoucherList(usersToLoad));
    }
  };

  const handleUpdateVoucher = async (values: any) => {
    setLoading(true);

    const tryCreateVouchers = await updateVouchers(id, {
      description: values.description,
      title: values.title,
      units: Number(values.units),
      start: moment(values.start).utc().format('YYYY-MM-DD HH:mm:ss'),
      expire: moment(values.expire).utc().format('YYYY-MM-DD HH:mm:ss'),
      charge_box_pks: values.charge_box_pks || null,
      tenant_pk: user.tenant_pk,
      user_pks:
        userPks.map(
          (user: VoucherUserSelectedPksWithVoucherStatus) =>
            user?.user_pk || user,
        ) || null,
      uses_per_user: values.uses_per_user || 1,
      expire_type: values.expire_type || VoucherExpireType.ExpirationDate,
      kind: values.kind,
      active: values.active,
      kind_value:
        values.kind === 'MONEY_RECHARGE'
          ? rawMaskMoney(values.kind_value)
          : Number(values.kind_value),
    });

    if (tryCreateVouchers.type === 'error') {
      setError(true);
    } else if (tryCreateVouchers.type === 'success') {
      setSuccess(true);
    }

    setLoading(false);
  };

  const handleSaveChanges = (values) => {
    dispatch(setVoucherFormValues(values));
  };

  const handleGoBack = () => {
    clearVoucherTemporaryValues();

    history.push(`/voucher/${id}`);
  };

  return (
    <>
      {voucherDetail && (
        <S.Wrapper>
          <PageHeader
            onBack={handleGoBack}
            title={
              <>
                <VoucherIcon
                  style={{ position: 'relative', top: 3, marginRight: 16 }}
                  fill={COLORS.black}
                  height={20}
                  width={20}
                />
                Editar Voucher
              </>
            }
          />

          <S.Blank>
            <VoucherForm
              initialValues={
                shouldUseFormValues
                  ? {
                      ...formValues,
                      kind_value:
                        formValues.kind === 'MONEY_RECHARGE'
                          ? Number(formValues.kind_value).toFixed(2)
                          : formValues.kind_value,
                      active: voucherDetail.status === 'ACTIVE' ? true : false,
                    }
                  : {
                      ...voucherDetail,
                      kind_value:
                        voucherDetail.kind === 'MONEY_RECHARGE'
                          ? Number(voucherDetail.kind_value).toFixed(2)
                          : voucherDetail.kind_value,
                      active: voucherDetail.status === 'ACTIVE' ? true : false,
                    }
              }
              onSaveChanges={handleSaveChanges}
              loading={loading}
              isActivation={getUsersWhoActivedVoucher()}
              chargePointsList={chargePointsList}
              onSubmit={handleUpdateVoucher}
              isEdit={true}
            />
          </S.Blank>
        </S.Wrapper>
      )}

      <Modal visible={success} closable={false} footer={null}>
        <Result
          status='success'
          title='Voucher atualizado com sucesso!'
          extra={[
            <S.Button
              type='primary'
              key='console'
              size='large'
              onClick={() => {
                clearVoucherTemporaryValues();

                history.push('/vouchers');
              }}
            >
              Ver listagem atualizada
            </S.Button>,
          ]}
        />
      </Modal>
      <Modal visible={error} closable={false} footer={null}>
        <Result
          status='error'
          title='Não foi possível atualizar o Voucher!'
          extra={[
            <S.Button
              key='default'
              size='large'
              onClick={() => {
                clearVoucherTemporaryValues();

                history.push('/vouchers');
              }}
            >
              Ver listagem
            </S.Button>,
            <S.Button
              type='primary'
              key='primary'
              size='large'
              onClick={() => setError(false)}
            >
              Tentar novamente
            </S.Button>,
          ]}
        />
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  chargePointsList: state.chargePoints.chargePoints.chargePointList,
});

export default connect(mapStateToProps)(VoucherEditPage);
